module.exports = __webpack_public_path__ + "images/accents/accent-team-administration@1x-dfcc70db62cdb2845edb3934e0344b5f.webp";